import type { ReactNode } from 'react'
import { Palette, Type, PanelTop, PanelLeft, Layout } from 'lucide-react'
import type { ThemeConfig } from '@/types/theme'

export type AppearanceColorField = {
  key: keyof ThemeConfig
  label: string
  supportsAlpha: boolean
}

export type AppearanceColorGroup = {
  title: string
  icon: ReactNode
  desc: string
  colors: AppearanceColorField[]
}

export const APPEARANCE_COLOR_GROUPS: AppearanceColorGroup[] = [
  {
    title: 'Cores da Marca',
    icon: <Palette size={14} className="text-accent" />,
    desc: 'Botões, links e elementos de destaque',
    colors: [
      { key: 'brandPrimary', label: 'Cor Principal — Botões e Links', supportsAlpha: false },
      { key: 'brandPrimaryHover', label: 'Principal Hover', supportsAlpha: false },
      { key: 'brandPrimaryMuted', label: 'Principal Muted (Fundo de badges)', supportsAlpha: true },
      { key: 'brandSecondary', label: 'Cor Secundária — Sucesso', supportsAlpha: false },
      { key: 'brandSecondaryHover', label: 'Secundária Hover', supportsAlpha: false },
    ],
  },
  {
    title: 'Cores de Texto',
    icon: <Type size={14} className="text-accent" />,
    desc: 'Hierarquia tipográfica H1, H2, H3...',
    colors: [
      { key: 'fontColorH1', label: 'H1 — Títulos Principais', supportsAlpha: false },
      { key: 'fontColorH2', label: 'H2 — Subtítulos', supportsAlpha: false },
      { key: 'fontColorH3', label: 'H3 — Cabeçalho de Seção', supportsAlpha: false },
      { key: 'fontColorH4', label: 'H4 — Subseção', supportsAlpha: false },
      { key: 'fontColorH5', label: 'H5 — Tópico', supportsAlpha: false },
      { key: 'fontColorH6', label: 'H6 — Subtópico', supportsAlpha: false },
      { key: 'fontColorBody', label: 'Body — Texto Corpo', supportsAlpha: false },
      { key: 'fontColorMuted', label: 'Muted — Texto Secundário', supportsAlpha: false },
      { key: 'fontColorLabel', label: 'Label — Captions e Badges', supportsAlpha: false },
    ],
  },
  {
    title: 'Supertopo (Header)',
    icon: <PanelTop size={14} className="text-accent" />,
    desc: 'Barra superior da aplicação — fundo e cor do texto/ícones',
    colors: [
      { key: 'bgHeader', label: 'Fundo do Supertopo', supportsAlpha: false },
      { key: 'textHeader', label: 'Texto e Ícones do Supertopo', supportsAlpha: false },
    ],
  },
  {
    title: 'Menu Lateral (Sidebar)',
    icon: <PanelLeft size={14} className="text-accent" />,
    desc: 'Painel de navegação lateral — fundo, item ativo e texto',
    colors: [
      { key: 'bgSidebar', label: 'Fundo Base do Menu (sob o degradê)', supportsAlpha: false },
      { key: 'textSidebar', label: 'Texto e Ícones do Menu', supportsAlpha: false },
      { key: 'navActiveColor', label: 'Item Ativo — Cor (texto/ícone)', supportsAlpha: false },
      { key: 'navActiveMuted', label: 'Item Ativo — Fundo', supportsAlpha: true },
    ],
  },
  {
    title: 'Página e Cards',
    icon: <Layout size={14} className="text-accent" />,
    desc: 'Fundo da área de conteúdo, cards e painéis internos',
    colors: [
      { key: 'bgMain', label: 'Fundo da Página (área de conteúdo)', supportsAlpha: false },
      { key: 'bgCard', label: 'Fundo dos Cards e Modais', supportsAlpha: false },
      { key: 'bgDark', label: 'Fundo Auxiliar (sombras e contraste)', supportsAlpha: false },
      { key: 'textPrimary', label: 'Texto Primário (geral)', supportsAlpha: false },
      { key: 'textSecondary', label: 'Texto Secundário (geral)', supportsAlpha: false },
      { key: 'textMuted', label: 'Texto Muted (geral)', supportsAlpha: false },
    ],
  },
]
